<template>
	<v-container
		class="brightBackground"
		fluid
		style="min-height: 100%"
	>
		
		<v-container fluid style="max-width: 1000px;" class="pt-xs-0 pt-sm-0 pt-md-0 pt-lg-6">

			<v-row>

				<v-col class="pt-0 pa-0 ma-0">

					<v-subheader class="display-1 font-weight-bold ml-0 pl-1 pb-0 grey--text text--darken-3">Projects</v-subheader>

					<v-toolbar
						dense
						flat
						color="toolbarSecondary"
					>
						<v-btn
							color="iconTextColor"
							text
							small
							class="ml-n4"
							height="32"
							router to="/admin/newproject"
						>
							<v-icon medium>mdi-television-clean</v-icon>
							<span class="ml-2">New project</span>
						</v-btn>

					</v-toolbar>

					<!-- Clients listed -->
					<v-card
						v-for="client in filteredDataProvider" :key="client.name"
						color="boxOnBrightBackground"
						flat
						class="pa-3 mb-4 pb-1"
					>


						<div align="left" class="title primary--text text--darken-3 pb-2">{{client.name}}</div>


						<!-- Project groups listed -->
						<v-card
							v-for="(group, j) in client.groups" :key="j"
							color="boxOnBrightBackground"
							flat
							
						>

							<div align="left" class="subtitle-1 font-weight-medium accent--text text--darken-3 pb-1 pt-1">{{ group.name }}</div>


							<!-- -------------------------------------------- -->
							<!--   Expansion panel (Projects) -->
							<!-- -------------------------------------------- -->

							<v-expansion-panels multiple class="pb-3">

								<v-expansion-panel v-for="(project, i) in group.projects" :key="i">
									
									<!-- Expanded panel header-->
									<v-expansion-panel-header color="grey lighten-4 primary--text text--darken-1">
										<b>{{ project.name }}</b>
									</v-expansion-panel-header>

									<!-- Expanded panel -->
									<v-expansion-panel-content>
										<v-container fluid class="pt-6 pb-0 px-1">

											<v-row>
												
												<v-col cols="12" md="8" xl="8" class="px-3 pb-0">
													<!-- <v-row>

														<v-col cols="12" class="px-3 pb-0"> --> <!-- xs="12" sm="12" md="8" xl="8" -->
															<v-text-field
																label="Project name"
																v-model="project.name"
																outlined
																dense
															></v-text-field>

															<v-text-field
																label="Project pretty name"
																v-model="project.prettyName"
																outlined
																dense
															></v-text-field>
														<!-- </v-col>

													</v-row> -->
												</v-col>

												<v-col cols="12" xs="12" sm="12" md="4" xl="4" class="px-3 pb-0">
													<v-text-field
														label="Project variable name"
														v-model="project.variable"
														outlined
														dense
													/>
													<v-text-field
														label="Project key"
														v-model="project.key"
														disabled
														outlined
														dense
													/>
												</v-col>

												<!-- <v-col cols="12" xs="12" sm="12" md="4" xl="4" class="px-3 pb-0">
													
												</v-col> -->

											</v-row>

											<v-col cols="12" xs="12" sm="12" md="8" xl="8" class="px-3 pb-0 pt-0">
												<v-checkbox
													class="pt-0 mt-0"
													v-model="project.public"
													label="App/website is public and readable without authentication"
												></v-checkbox>
											</v-col>

											

											<v-row class="mb-n3">
												
												<v-col align="left">
													<div class="caption grey--text text--lighten-1">{{ project.id }}</div>
												</v-col>

												<v-col align="right">
													<icon-text-button b-icon="mdi-delete" @click="disableProject(project)">Disable project</icon-text-button>
													<icon-text-button b-icon="mdi-content-save" @click="saveProject(project)">Save changes</icon-text-button>
												</v-col>
												
											</v-row>

										</v-container>

									</v-expansion-panel-content>
								</v-expansion-panel>


							</v-expansion-panels>

						</v-card>

					</v-card>

				</v-col>
			</v-row>
			
		</v-container>

	</v-container>
</template>



<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from '@/shift/agile';
import agileFb from '@/shift/agileFb';
import fb from '@/shift/fb';

export default
{
	name: 'Projects',

	// ----------------------------------
	//	VUE: Data and computed
	// ----------------------------------

	data: () =>
	({
		// Variable for filling the height between top toolbar and bottom
		filteredDataProvider: [],
		clients: [],
		groups: [],
		projects: [],
		firestoreLiveConnections: [],
	}),

	computed:
	{
		agile()
		{
			return agile;
		},
	},


	// ----------------------------------
	//	VUE: Watching things
	// ----------------------------------

	watch:
	{
		// ----------------------------------
		//	Check if clients got its groups updated
		// ----------------------------------

		clients: function()
		{
			this.buildDataProvider();
		},

		groups: function()
		{
			this.buildDataProvider();
		},
		
		projects: function()
		{
			this.buildDataProvider();
		}
	},

	// ----------------------------------------------------
	//
	//  VUE: Create and Mount
	//
	// ----------------------------------------------------

	created()
	{

		// ----------------------------------
		//	Load client list and let it
		//  live reload!
		// ----------------------------------
		
		this.firestoreLiveConnections.push(

			fb.db.collection('clients').onSnapshot(res =>
			{
				const changes = res.docChanges();

				changes.forEach(change =>
				{

					// ----------------------------------
					//	Content added
					// ----------------------------------

					if (change.type === 'added')
					{
						this.clients.push(
						{
							...change.doc.data(),
							id: change.doc.id
						})
					}


					// ----------------------------------
					//	Content modified
					// ----------------------------------

					if (change.type === "modified")
					{
						for (let i = 0; i < this.clients.length; i++)
						{
							if (this.clients[i].id == change.doc.id)
							{
								var uD = change.doc.data();
								this.clients[i].name = uD.name;
								this.clients[i].variable = uD.variable;
								this.clients[i].prefix = uD.prefix;
								this.clients[i].key = uD.key;
								this.clients[i].id = change.doc.id;
							}
						}
					}


					// ----------------------------------
					//	Content deleted
					// ----------------------------------

					if (change.type === "removed")
					{
						for (let i = 0; i < this.clients.length; i++)
						{
							if (this.clients[i].id == change.doc.id)
							{
								this.clients.splice(i, 1);
							}
						}
					}
				});

				// ----------------------------------
				//	Sort alphabetically by name
				// ----------------------------------

				this.agile.sortBy(this.clients, 'name');


			},
			er =>
			{
				this.$root.$alert("Error", er.message);
			})
		);




		// ----------------------------------
		//	Load project group list and let it
		//  live reload!
		// ----------------------------------
		
		this.firestoreLiveConnections.push(

			fb.db.collection('project-groups').onSnapshot(res =>
			{
				const changes = res.docChanges();

				changes.forEach(change =>
				{

					// ----------------------------------
					//	Content added
					// ----------------------------------

					if (change.type === 'added')
					{
						this.groups.push(
						{
							...change.doc.data(),
							id: change.doc.id
						})
					}


					// ----------------------------------
					//	Content modified
					// ----------------------------------

					if (change.type === "modified")
					{
						for (let i = 0; i < this.groups.length; i++)
						{
							if (this.groups[i].id == change.doc.id)
							{
								var uD = change.doc.data();
								this.groups[i].name = uD.name;
								this.groups[i].variable = uD.variable;
								this.groups[i].prefix = uD.prefix;
								this.groups[i].clients = uD.clients;
								this.groups[i].id = change.doc.id;
							}
						}
					}


					// ----------------------------------
					//	Content deleted
					// ----------------------------------

					if (change.type === "removed")
					{
						for (let i = 0; i < this.groups.length; i++)
						{
							if (this.groups[i].id == change.doc.id)
							{
								this.groups.splice(i, 1);
							}
						}
					}
				});

				// ----------------------------------
				//	Sort alphabetically by name
				// ----------------------------------

				this.agile.sortBy(this.groups, 'name');

			},
			er =>
			{
				this.$root.$alert("Error", er.message);
			})
		);
		




		// ----------------------------------
		//	Load project list and let it
		//  live reload!
		// ----------------------------------
		
		this.firestoreLiveConnections.push(

			fb.db.collection('projects').where('disabled', '==', false).onSnapshot(res =>
			{
				const changes = res.docChanges();

				changes.forEach(change =>
				{

					// ----------------------------------
					//	Content added
					// ----------------------------------

					if (change.type === 'added')
					{
						this.projects.push(
						{
							...change.doc.data(),
							id: change.doc.id
						})
					}


					// ----------------------------------
					//	Content modified
					// ----------------------------------

					if (change.type === "modified")
					{
						for (let i = 0; i < this.projects.length; i++)
						{
							if (this.projects[i].id == change.doc.id)
							{
								var uD = change.doc.data();
								this.projects[i].name = uD.name;
								this.projects[i].variable = uD.variable;
								this.projects[i].prefix = uD.prefix;
								this.projects[i].clients = uD.clients;
								this.projects[i].id = change.doc.id;
								this.projects[i].public = uD.public;
								this.projects[i].prettyName = uD.prettyName;

							}
						}
					}


					// ----------------------------------
					//	Content deleted
					// ----------------------------------

					if (change.type === "removed")
					{
						for (let i = 0; i < this.projects.length; i++)
						{
							if (this.projects[i].id == change.doc.id)
							{
								this.projects.splice(i, 1);
							}
						}
					}
				});

				// ----------------------------------
				//	Sort alphabetically by name
				// ----------------------------------

				this.agile.sortBy(this.projects, 'name');

			},
			er =>
			{
				this.$root.$alert("Error", er.message);
			})
		);



	},

	mounted()
	{
		
	},


	// --------------------------------------------------------------------
	//
	//	VUE: Methods
	//
	// --------------------------------------------------------------------

	methods:
	{
		
		// ----------------------------------
		//	Structue group data into clients
		// ----------------------------------

		buildDataProvider()
		{
			// This function makes a tree structure of client/group/project, and only if there are projects present.
			// Probably a stupid way to do it, but it works...

			this.filteredDataProvider = new Array();

			for (let i = 0; i < this.clients.length; i++)
			{
				
				let groups = new Array();

				for (let j = 0; j < this.groups.length; j++)
				{
					if (this.clients[i].id == this.groups[j].clientId)
					{
						let projects = new Array();

						for (let k = 0; k < this.projects.length; k++)
						{
							if (this.groups[j].id == this.projects[k].groupId)
							{
								projects.push(this.projects[k]);
							}
						}

						if (projects.length > 0)
						{
							groups.push(this.groups[j]);
							this.groups[j].projects = projects;
						}
					}
				}
				
				if (groups.length > 0)
				{
					this.filteredDataProvider.push(this.clients[i]);
					this.clients[i].groups = groups;
				}
				
			}
			
		},

		
		// ----------------------------------
		//	Save client data
		// ----------------------------------
		
		saveProject(project)
		{
			// Todo: Validate god damn it
			this.$root.$confirm('Careful', 'Changes in these settings can affect the project in many ways, and the project can break. Still want to change?', { color: 'warning' } )
			.then((confirm) =>
			{
				if (confirm)
				{
					// ----------------------------------
					//	Create client in Firebase
					// ----------------------------------

					fb.db.collection("projects").doc(project.id).update(
					{
						name: project.name,
						variable: project.variable,
						prettyName: project.prettyName,
						groupId: project.groupId,
						public: project.public,
					})
					.then(() =>
					{
						this.$root.ai_app.snackbarText = 'Project updated';
						this.$root.ai_app.snackbarTimeout = 3000;
						this.$root.ai_app.snackbar = true;
						agileFb.updateSecurityRules();
						this.$root.$updateUserProjects();
					})
					.catch((error) =>
					{
						this.$root.$alert("Error", error.message);
					});
				}
			});
		},


		// ----------------------------------
		//	Disable project
		// ----------------------------------

		disableProject(project)
		{
			this.$root.$confirm('Careful', 'Disabeling projects will take it offline, and users can not log in. Still want to disable?', { color: 'warning' } )
			.then((confirm) =>
			{
				if (confirm)
				{
					fb.db.collection("projects").doc(project.id).update(
					{
						disabled: true
					})
					.then(() =>
					{
						this.$root.ai_app.snackbarText = 'Project disabled';
						this.$root.ai_app.snackbarTimeout = 3000;
						this.$root.ai_app.snackbar = true;
						this.$root.$updateUserProjects();
					})
					.catch((error) =>
					{
						this.$root.$alert("Error", error.message);
					});
				}
			});

		},
		
	},


	// --------------------------------------------------------------------
	//
	//	VUE: Destroy event hook
	//
	// --------------------------------------------------------------------
	
	beforeDestroy()
	{
		// Unsubscribe live listeners
		for (let i = 0; i < this.firestoreLiveConnections.length; i++)
		{
			this.firestoreLiveConnections[i]();
		}
	},
		
}
</script>